// removed by extract-text-webpack-plugin
module.exports = {"Container":"_3LPmkI0eQs2K9TzqfrRHxm","ChartColumn":"_2h3zkYLWUG_wLogqOVGJYN","TableColumn":"kvQOzuMsVY9tQ2hN3xFZe","Table":"_1jIZZSkp-ZIqpUSUXNAMzc","Empty":"_3NqkcR8vaEG-_nYfcLS4fG"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/CountryWidget/styles.module.css
// module id = 199
// module chunks = 0